// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
const PREFIX = 'KardiaRx.';
export const CCT_WORKLIST_DATA_REQUEST = `${PREFIX}CCT_WORKLIST_DATA_REQUEST`;
export const CCT_WORKLIST_DATA_SUCCESS = `${PREFIX}CCT_WORKLIST_DATA_SUCCESS`;
export const CCT_WORKLIST_DATA_FAILURE = `${PREFIX}CCT_WORKLIST_DATA_FAILURE`;

export const CCT_WORKLIST_DD_REQUEST = `${PREFIX}CCT_WORKLIST_DD_REQUEST`;
export const CCT_WORKLIST_DD_SUCCESS = `${PREFIX}CCT_WORKLIST_DD_SUCCESS`;
export const CCT_WORKLIST_DD_FAILURE = `${PREFIX}CCT_WORKLIST_DD_FAILURE`;

export const CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS = `${PREFIX}CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS`;
export const CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT = `${PREFIX}CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT`;
export const CCT_WORKLIST_FILTER_CLEAR = `${PREFIX}CCT_WORKLIST_FILTER_CLEAR`;

export const CCT_WORKLIST_PAGINATION_TOKEN_CLEAR = `${PREFIX}CCT_WORKLIST_PAGINATION_TOKEN_CLEAR`;

export const CCT_WORKLIST_PAGINATION_TOKEN_ADD = `${PREFIX}CCT_WORKLIST_PAGINATION_TOKEN_ADD`;

export const CCT_WORKLIST_PAGINATION_TOKEN_REMOVE = `${PREFIX}CCT_WORKLIST_PAGINATION_TOKEN_REMOVE`;

export const CCT_PAGE_NO_UPDATE = `${PREFIX}CCT_PAGE_NO_UPDATE`;

export const CCT_Practice_Id_UPDATE = `${PREFIX}CCT_Practice_Id_UPDATE`;

export const CCT_Provider_Id_UPDATE = `${PREFIX}CCT_Provider_Id_UPDATE`;

export const CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR = `${PREFIX}CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR`;

export const CCT_WORKLIST_DD_FAILURE_RE_ROUTE = `${PREFIX}CCT_WORKLIST_DD_FAILURE_RE_ROUTE`;

export const CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR = `${PREFIX}CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR`;

export const CCT_WORKLIST_CORRUPTED_DATA_SUCCESS = `${PREFIX}CCT_WORKLIST_CORRUPTED_DATA_SUCCESS`;

export const CCT_WORKLIST_CORRUPTED_DATA_REQUEST = `${PREFIX}CCT_WORKLIST_CORRUPTED_DATA_REQUEST`;



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxCCTWorklist/types.js